module.exports = __webpack_public_path__ + "stu-res/img/icon-2.b9a06740.png";